import { Component } from '@angular/core';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { UserService } from 'src/app/auth/service/user.service';
import { UserTaskStatusService } from 'src/app/services/user-task-status.service';
import { WeeklyReportService } from 'src/app/services/weekly-report.service';

@Component({
  selector: 'app-programme-weekly-reports',
  templateUrl: './programme-weekly-reports.component.html',
  styleUrls: ['./programme-weekly-reports.component.scss'],
})
export class ProgrammeWeeklyReportsComponent {
  isLoading = false;
  currentWeekNumber!: number;
  userData: any;
  reportsRead: any = [];

  constructor(
    private userService: UserService,
    private weeklyReportService: WeeklyReportService,
    private userTaskStatusService: UserTaskStatusService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.userService.userData.subscribe((userData) => {
      if (userData) {
        this.userData = userData;
        this.currentWeekNumber =
          moment().diff(moment(userData.date_registered).startOf('week'), 'week') + 1;
      }
    });

    forkJoin({
      allTaskStatuses: this.userTaskStatusService.fetchAll(),
    }).subscribe((responseData) => {
      this.reportsRead = this.weeklyReportService.getReportsRead(responseData.allTaskStatuses);
      this.isLoading = false;
    });
  }

  onShowReport(week: number) {
    this.weeklyReportService.showReport.next(true);
    this.weeklyReportService.activeWeek.next(week);
    this.reportsRead.push(week);
  }
}
